import Layout from "../include/layout";
import { Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from 'dayjs'
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'datatables.net-bs5'
import CalendriersevaluationsService from "./CalendriersevaluationsService";
import TypesevaluationsService from "../typesevaluations/TypesevaluationsService";
import EnseignantsService from "../enseignants/EnseignantsService";
import MatieresService from "../matieres/MatieresService";
import Filarial from "../include/filarial";


export default function CalendriesEvaluationsIndex() {
    const token = useSelector(state => state.auth.token)
    const [calendriersevaluations, setCalendriersevaluations] = useState([])
    const [enseignants, setEnseignants] = useState([])
    const [typesevaluations, setTypesEvaluations] = useState([]);
    const [matieres, setMatieres] = useState([])
    const activeLink = "CALENDRIER EVALUATIONS"


    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    //get liste type evaluation
    const fetchTypesevaluations = async () => {
        await TypesevaluationsService.index(token).then((res) => {
            setTypesEvaluations(res.data.data)
        }).catch(error => {
            console.log(error)
        })
    }

    //get liste enseignants
    const fetchEnseignants = async () => {
        await EnseignantsService.index(token).then((res) => {
            setEnseignants(res.data.data)
        }).catch(error => {
            console.log(error)
        })
    }

    //get liste matieres
    const fetchMatieres = async () => {
        await MatieresService.index(token).then((res) => {
            setMatieres(res.data.data)
        }).catch(error => {
            console.log(error)
        })
    }




    //get liste calendriers evaluations
    const fetchCalendriersevaluations = async () => {
        await CalendriersevaluationsService.index(token).then((res) => {
            //console.log(res.data.data)
            setCalendriersevaluations(res.data.data)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }

    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.calendriersevaluations_edit, { state: { id: param } })
    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                CalendriersevaluationsService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchCalendriersevaluations()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }



    useEffect(() => {
        fetchCalendriersevaluations();
        fetchTypesevaluations();
        fetchMatieres();
        fetchEnseignants();
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
    }, [dispatch])


    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Filarial activeLink={activeLink} />

                {/* Responsive Datatable */}
                <div className="card shadow-lg mb-3 mt-2">
                    <h5 className="card-header">Liste des calendriers évaluations <Link className="btn btn-primary btn-sm" title="Ajouter">
                        <FontAwesomeIcon icon="fa-solid fa-circle-plus" /></Link></h5>
                    <div className="card-datatable table-responsive px-4 pb-3">
                        <table className="dt-responsive table border-top data-table table-hover ">
                            <thead className="bg-primary">
                                <tr style={{ color: "white" }}>
                                    <th className="cell text-white">#</th>
                                    <th className="cell text-white">Type Evaluation</th>
                                    <th className="cell text-white">Matière</th>
                                    <th className="cell text-white">Enseignant</th>
                                    <th className="cell text-white">Date programmation</th>
                                    <th className="cell text-white">Date début Evaluation</th>
                                    <th className="cell text-white">Date fin Evaluation</th>
                                    <th className="cell text-white">Description</th>
                                    <th className="cell text-white">Statuts</th>
                                    <th className="cell text-white">Date modifcation</th>
                                    <th className="cell text-white">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {calendriersevaluations.length > 0 && calendriersevaluations.map((item, index) => (
                                    <tr key={index}>
                                        <td className="cell">{index + 1}</td>
                                        <td className="cell">{item.typesevaluations?.libelleTypeEvaluation}</td>
                                        <td className="cell">{item.matieres?.libelleMatiere}</td>
                                        <td className="cell">{item.nomEnseignant + " " + item.prenomsEnseignant}</td>
                                        <td className="cell">{item.dateCalendrierEvaluation}</td>
                                        <td className="cell">{item.dateDebutCalendrierEvaluation}</td>
                                        <td className="cell">{item.dateFinCalendrierEvaluation}</td>
                                        <td className="cell">
                                            {item.descriptionCalendrierEvaluation}
                                        </td>
                                        <td className="cell">
                                            <span class={item.statuts?.libelleStatut === "ACTIF" ? 'badge rounded-pill bg-success' : 'badge rounded-pill bg-warning'}>{item.statuts?.libelleStatut}</span>
                                        </td>
                                        <td className="cell">
                                            <span>{dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}</span>
                                        </td>
                                        <td className="cell">
                                            <div className="d-flex">
                                                <Button className="btn btn-sm" variant="primary" onClick={() => goToEdit(item.id)}
                                                    title="Modifier">
                                                    <i className="fas fa-edit"></i></Button> &nbsp;&nbsp;
                                                <Button className="btn btn-sm" variant="danger" onClick={() => onDelete(item.id)}
                                                    title="Supprimer">
                                                    <i className="fas fa-trash"></i></Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/*/ Responsive Datatable */}

            </div>

        </Layout>
    )
}